<div class="orgcontainer">
  <span (click)="logoClicked()" class="navbar-nav ">
    <a class="navbar-brand">
      <app-orglogo  [showFileDialog]="false" [imgtype]="imgtype" [whitelabeled]="moduleWhitelabel" ></app-orglogo>
    </a>
  </span>
</div>